import { Grid } from '@mui/material';
import ChipInput from '../../ChipInput/ChipInput';
import React from 'react';
import './queryDatabase.css';

export const RecordIdInput = props => {
  const { index, queryData, aData, placeholders } = props;

  const addRecordIdValue = (index, value, queryData) => {
    let aData = queryData[index];
    const currentRecordIds = aData.rowIds || [];
    const doesPlaceholderExist = placeholders[0]?.placeholders.find(
      placeholder => placeholder.key === value
    );
    if (doesPlaceholderExist) {
      value = '${' + value + '}';
    }

    aData.rowIds = [...currentRecordIds, value];

    props.setQueryData(queryData);
  };

  const deleteRecordIdValueByIndex = (queryDataIndex, indexToDelete, queryData) => {
    let aData = queryData[queryDataIndex];
    if (!aData?.rowIds) return;

    aData.rowIds.splice(indexToDelete, 1);

    props.setQueryData(queryData);
  };

  const isChipAvailable = chip => {
    return chip && chip.trim().length > 0;
  };

  return (
    <Grid container>
      <Grid className="label-grid" item xs={2}>
        <p className="styled-paragraph">Return all rows matching these record IDs</p>
      </Grid>
      <Grid item>
        <ChipInput
          className="record-id-chip-input"
          onPlaceholderSelected={event => {
            addRecordIdValue(index, event.key, queryData);
          }}
          placeholders={props.placeholders}
          onBeforeAdd={chip => {
            if (isChipAvailable(chip)) {
              addRecordIdValue(index, chip, queryData);
              return true;
            }
            return false;
          }}
          placeholder="Insert record IDs or placeholders"
          inputValue={aData.rowIds ? aData.rowIds : []}
          onDelete={inputIndex => {
            deleteRecordIdValueByIndex(index, inputIndex, queryData);
          }}
          onFocus={() => {
            props.setThisFocus(index, 0);
          }}
        />
      </Grid>
    </Grid>
  );
};
